import { render, staticRenderFns } from "./IconUserTag.vue?vue&type=template&id=1962a8e5"
import script from "./IconUserTag.vue?vue&type=script&setup=true&lang=ts"
export * from "./IconUserTag.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports